import React, { useState } from "react";
import { Platform, Text, View } from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import * as Calendar from "expo-calendar";
import Queries from "../../api/queries";
import Colors from "../../Theme/Colors";
import { startOfMonth, endOfMonth } from "date-fns";
import LoadingModal from "../LoadingModal";
import typo from "../../Theme/Typo";
import { useTranslation } from "react-i18next";
import OiqiaModal from "../OiqiaModal";
import ModalQLerr from "../../utils/ModalQLerr";

const ExportCalendar = ({ date }) => {
  const [QLerror, setQLerror] = useState("");
  const [isOpen, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const { t, i18n } = useTranslation();

  const queries = new Queries();

  /*     useEffect(() => {
            requestPremission();
        }, [])
     */
  const requestPremission = async () => {
    const { status } = await Calendar.requestCalendarPermissionsAsync();
    let agendaId;

    if (status === "granted") {
      if (Platform.OS == "ios") {
        agendaId = (await Calendar.getDefaultCalendarAsync()).id;
      } else if (Platform.OS == "android") {
        const calendar = await (
          await Calendar.getCalendarsAsync()
        ).find((calendar) => calendar.name == "Prestation OIQIA");
        if (!calendar) {
          const id = await Calendar.createCalendarAsync({
            title: "Prestation OIQIA",
            color: Colors.oiqia,
            entityType: Calendar.EntityTypes.EVENT,
            source: { isLocalAccount: true, name: "Prestation OIQIA" },
            name: "Prestation OIQIA",
            ownerAccount: "Work",
            accessLevel: Calendar.CalendarAccessLevel.OWNER,
          });
          agendaId = id;
        } else {
          agendaId = calendar.id;
        }
      }
    }
    return agendaId;
  };

  const addEventToCalendar = async () => {
    const calendarId = await requestPremission();

    if (!calendarId) {
      alert("Calendar permission required to export events");
      return;
    }

    setOpen(true);
    const startMonth = startOfMonth(new Date(date));
    const endMonth = endOfMonth(new Date(date));
    const calendar = await Calendar.getEventsAsync(
      [calendarId],
      startMonth,
      endMonth
    );
    let nbOfEventAdded = 0;
    try {
      const data = await queries.getEventOfMonth(date);

      let errors = data?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const { events } = data?.data.getEventOfMonth;
        events?.forEach((event) => {
          const eventInCalendar = calendar.find(
            (eventTemp) => eventTemp.title == event.title
          );
          if (!eventInCalendar) {
            nbOfEventAdded++;
            Calendar.createEventAsync(calendarId, {
              calendarId,
              title: event.title,
              timeZone: event.timeZone,
              startDate: event.startDate,
              endDate: event.endDate,
              location: event.location,
              notes: event.notes,
            });
          }
        });
        if (nbOfEventAdded > 0) {
          setMessage(`${nbOfEventAdded} ${t("AGENDA_POP_CONTENT")}`);
        } else {
          setMessage(t("AGENDA_POP_CONTENT_EMPTY"));
        }
      }
    } catch (err) {
      setQLerror(err);
    }
  };

  return (
    <View style={{ marginRight: 20 }}>
      <AntDesign
        name="calendar"
        size={25}
        color="white"
        onPress={() => addEventToCalendar()}
      />
      <View>
        <OiqiaModal
          isOpen={isOpen}
          titleText={t("AGENDA_POP_TITLE")}
          onClose={() => setOpen(false)}
          bodyText={
            <View style={{ marginTop: 20 }}>
              <Text style={typo.body}>{message}</Text>
            </View>
          }
          firstButtonData={{
            text: t("AGENDA_POP_BUTTON"),
            callback: () => setOpen(false),
          }}
        />
      </View>
      {QLerror && QLerror !== "" ? (
        <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
      ) : null}
    </View>
  );
};

export default ExportCalendar;
